import { render, staticRenderFns } from "./Type_control.vue?vue&type=template&id=33c9d9dd"
import script from "./Type_control.vue?vue&type=script&lang=js"
export * from "./Type_control.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports